import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Pipe({
  name: 'containsKey',
  standalone: true,
})
export class ContainsKeyPipe implements PipeTransform {
  transform(array: ValidationErrors | null, key: string): unknown {
    if (!array) {
      return false;
    }

    return array[key] !== undefined;
  }
}
